import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { params, shape, string } from '@thd-nucleus/data-sources';
import { useLayoutGroupProps } from '@thd-olt-component-react/layout-manager';
import { RedirectContext } from './RedirectContext';
import { usePIPRedirectRules } from './rules/pip-redirect-rules';
import { getPathWithMergedParams } from '../utils/redirector-utils';

const ssrDefault = typeof window === 'undefined';

export const PIPRedirector = ({
  ssr = ssrDefault,
  ...props
}) => {

  if (!ssr) return null;

  const {
    disablePEPRedirect,
    disableCanonicalRedirect,
    disableReviewsRedirect,
    disableCMMMCRedirect
  } = useLayoutGroupProps({ props });

  const { pathWithQueryParams, itemId, redirectState, bypass, timeoutRecovery } = useContext(RedirectContext);

  if (bypass) {
    redirectState.redirect = false;
    return null;
  }
  const [path, queryParams] = pathWithQueryParams.split('?');
  const redirectRules = usePIPRedirectRules({
    path,
    queryParams,
    itemId,
    disablePEPRedirect,
    disableReviewsRedirect,
    disableCanonicalRedirect,
    disableCMMMCRedirect,
    timeoutRecovery
  });
  const { shouldRedirect = false, redirectPath = '', httpCode = 200, isErrorStatus = false } = redirectRules;

  if (shouldRedirect || isErrorStatus) {
    const fullRedirectPath = queryParams ? `${getPathWithMergedParams(redirectPath, queryParams)}` : redirectPath;
    redirectState.redirect = shouldRedirect;
    redirectState.url = fullRedirectPath;
    redirectState.code = httpCode;
    redirectState.isErrorStatus = isErrorStatus;
  }

  return null;
};

PIPRedirector.propTypes = {
  ssr: PropTypes.bool,
  disablePEPRedirect: PropTypes.bool,
  disableCanonicalRedirect: PropTypes.bool,
  disableReviewsRedirect: PropTypes.bool,
  disableCMMMCRedirect: PropTypes.bool,
};

PIPRedirector.defaultProps = {
  ssr: ssrDefault,
  disablePEPRedirect: false,
  disableCanonicalRedirect: false,
  disableReviewsRedirect: false,
  disableCMMMCRedirect: false,
};

PIPRedirector.dataModel = {
  product: params({ itemId: string() }).shape({
    itemId: string(),
    dataSources: string(),
    identifiers: shape({
      canonicalUrl: string()
    })
  })
};
